import AbstractRequestTask from "../../AbstractRequestTask";
import Launcher from "../../../apa/Launcher";
import DeviceStorage from "../../../../components/DeviceStorage/DeviceStorage";
import Utils from '../../../../utils/Utils';
import Search from '../../../../utils/Search';
import AAF from "../../../../AAF/AAF";
import { EPG_VERSION_TTL} from '../../../../AAF/Resilence/TTLConstants';

const TTLItem = EPG_VERSION_TTL;

class PredictiveSearchV1Task extends AbstractRequestTask {
  constructor(parameters) {
    super();
    this.customParameters = parameters;
  }

   APAFilters(){
      return Utils.getApaMetadataKey('byr_filterlist_configuration', '{}', 'filterlist')
  }

  getHeaders() {
    return {};
  }

  getParams() {
    const params = super.getParams();
    delete params.HKS;
    delete params.api_version;
    delete params.device_id;
    delete params.device_name;
    delete params.device_so;
    AAF.TTLUtil.verifyTTLItem(TTLItem, () => { AAF.TTLUtil.setEpgVersion(); }, 'predictiveSearchTask[getParams]');
    const epg_version = DeviceStorage.getItem('epgVersion');
    const APA =this.APAFilters();
    if(APA) {
      this.customParameters.filterlist = APA;
    }

    this.customParameters.epg_version = epg_version;

    const quantityParams = Search.getQuantity();
    delete quantityParams.genres;

    return Object.assign({}, params, this.customParameters, quantityParams);
  }

  getUrl() {
    const http = "https://";
    const url = Launcher.get("akamai_mfwk");

    return `${http}${url}/services/search/v1/predictive`;
  }

  success(data, b) {
    this.resolve(data);
  }
}

export default PredictiveSearchV1Task;



// WEBPACK FOOTER //
// ./src/requests/tasks/search/v1/PredictiveSearchV1Task.js